import { render, staticRenderFns } from "./CustomerEditView.vue?vue&type=template&id=06279e28&scoped=true"
import script from "./CustomerEditView.vue?vue&type=script&lang=ts"
export * from "./CustomerEditView.vue?vue&type=script&lang=ts"
import style0 from "./CustomerEditView.vue?vue&type=style&index=0&id=06279e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06279e28",
  null
  
)

export default component.exports